import { useState } from 'react';
import { ResolutionInput } from '../FramingChart/types';
import { CustomResolutionInput } from './CustomResolutionInput';
import { Toggle } from '@hawkins/components';
import { createResolutionFromValues } from '../utilities/createResolution';
import { Resolution } from 'src/domains/calculators/utilities/types';

type EffectiveCanvasInputProps = {
  effectiveCanvas: ResolutionInput;
  setEffectiveCanvas: (resolution: ResolutionInput) => void;
  canvasResolution?: Resolution | null;
};

export const EffectiveCanvasInput = ({
  effectiveCanvas,
  setEffectiveCanvas,
  canvasResolution,
}: EffectiveCanvasInputProps) => {
  const { width, height } = effectiveCanvas;

  const hasEffectiveCanvas = createResolutionFromValues(width, height) != null;

  const [showEffectiveCanvasInputs, setShowEffectiveCanvasInputs] =
    useState<boolean>(hasEffectiveCanvas);

  return (
    <>
      <Toggle
        aria-label="Toggle Effective Canvas Resolution Input"
        checked={showEffectiveCanvasInputs}
        label="Effective Canvas"
        onChange={(_event, checked) => {
          setShowEffectiveCanvasInputs(checked);
          setEffectiveCanvas({ width: null, height: null });
        }}
      />

      {showEffectiveCanvasInputs && (
        <CustomResolutionInput
          canvasResolution={canvasResolution ?? undefined}
          customHeight={effectiveCanvas.height}
          customWidth={effectiveCanvas.width}
          onChange={setEffectiveCanvas}
        />
      )}
    </>
  );
};
